import { Flex, Grid, Stack, Switch, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { Declaration } from '@e-origin/shared';

import { EucdmCode, HideElementFor, MultiLangCodes, TextInput } from '@components';
import { useCodeListSystem } from '@hooks/useCodeListSystem';
import { SellerForm } from '../SellerForm';
import { DeclarationStakeholdersFormValues } from './validateDeclarationStakeholdersForm';

interface StakeholderExporterSectionProps {
  form: UseFormReturnType<DeclarationStakeholdersFormValues>;
  editDisabled?: boolean;
  declaration: Declaration;
  isHighValue: boolean;
  declarationGroup: string;
}

export const StakeholderExporterSection: React.FC<StakeholderExporterSectionProps> = ({ form, editDisabled, declaration, isHighValue, declarationGroup }) => {
  const codelistSystems = useCodeListSystem({
    group: declarationGroup,
    isExport: declaration?.generalInfo?.isExport,
  });

  return (
    <Stack>
      <Stack mb="xl">
        <Flex justify="space-between" align="center">
          <Title order={5} fw={600}>
            Exporter
          </Title>
          <Switch
            {...form.getInputProps('stakeholders.exporter.header')}
            checked={form.values.stakeholders.exporter.header}
            label="Header"
            disabled={editDisabled}
            size="lg"
          />
        </Flex>

        <Grid>
          <Grid.Col span={6}>
            <EucdmCode path="stakeholders.exporter.name">
              <TextInput {...form.getInputProps('stakeholders.exporter.name')} label="Name" disabled={editDisabled} />
            </EucdmCode>
          </Grid.Col>
          <HideElementFor systems={['DECO', 'IDMS_LV']} declarationGroup={declarationGroup}>
            <Grid.Col span={6}>
              <EucdmCode path="stakeholders.exporter.identificationNumber">
                <TextInput {...form.getInputProps('stakeholders.exporter.identificationNumber')} label="Identification number" disabled={editDisabled} />
              </EucdmCode>
            </Grid.Col>
          </HideElementFor>
        </Grid>

        <Grid>
          <Grid.Col span={3}>
            <EucdmCode path="stakeholders.exporter.address.street">
              <TextInput {...form.getInputProps('stakeholders.exporter.address.street')} label="Street and number" disabled={editDisabled} />
            </EucdmCode>
          </Grid.Col>
          <Grid.Col span={3}>
            <EucdmCode path="stakeholders.exporter.address.postcode">
              <TextInput {...form.getInputProps('stakeholders.exporter.address.postcode')} label="Postcode" disabled={editDisabled} />
            </EucdmCode>
          </Grid.Col>
          <Grid.Col span={3}>
            <EucdmCode path="stakeholders.exporter.address.city">
              <TextInput {...form.getInputProps('stakeholders.exporter.address.city')} label="City" disabled={editDisabled} />
            </EucdmCode>
          </Grid.Col>
          <Grid.Col span={3}>
            <EucdmCode path="stakeholders.exporter.address.country">
              <MultiLangCodes
                {...form.getInputProps('stakeholders.exporter.address.country')}
                label="Country"
                code="CL199"
                disabled={editDisabled}
                system={codelistSystems}
              />
            </EucdmCode>
          </Grid.Col>
        </Grid>
      </Stack>

      {isHighValue && <SellerForm form={form} editDisabled={editDisabled} declarationGroup={declarationGroup} isExport={declaration?.generalInfo?.isExport} />}
    </Stack>
  );
};
